import { Component, Input, OnInit } from '@angular/core';
import { Industries } from '../../../../shared/util/industries';
import { BreakpointObserverService } from '../../../../shared/services/breakpoint-observer.service';
import {
  MenuGroupComponent,
  MenuGroupData,
} from './menu-group/menu-group.component';
import { LayersMenuService } from './layers-menu.service';
import {
  SpecialHealthCareComponent,
  UpcomingGroupData,
} from './upcoming-group/upcoming-group.component';
import {
  ALL_DATA_GROUP,
  CHARTS_GROUP,
  MAPS_GROUP,
  MenuGroupType,
  PLACES_GROUP,
} from '../../../map.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UserAccessService } from '../../../../user/access/user-access.service';
import { AsyncPipe, NgClass, NgForOf, NgIf, NgStyle } from '@angular/common';
import { FiltersMenuComponent } from './filters-menu/filters-menu.component';
import { MenuSearchComponent } from './menu-search/menu-search.component';
import { MenuSearchService } from './menu-search/menu-search.service';
import { SearchMenuPipe } from './menu-search/menu-search.pipe';
import { MenuPresetChipsComponent } from './menu-presets/menu-preset-chips.component';
import { FilterByPresetPipe } from './menu-presets/filter-by-preset.pipe';
import { MenuPresetService } from './menu-presets/menu-preset.service';

@Component({
  selector: 'app-layers-menu',
  templateUrl: './layers-menu.component.html',
  styleUrls: ['./layers-menu.component.scss', '../../../../app.component.scss'],
  imports: [
    NgStyle,
    NgIf,
    AsyncPipe,
    NgClass,
    ReactiveFormsModule,
    NgForOf,
    FiltersMenuComponent,
    MenuGroupComponent,
    SpecialHealthCareComponent,
    MenuSearchComponent,
    SearchMenuPipe,
    MenuPresetChipsComponent,
    FilterByPresetPipe,
  ],
})
export class LayersMenuComponent implements OnInit {
  @Input() activeMenuGroup!: MenuGroupType;
  @Input() industries!: any;
  @Input() isDropdownActive: boolean = false;
  @Input() industryDropdown = 'inner-industry';

  public isFiltersOpened: boolean = false;

  public form = new FormGroup({
    activeLayer: new FormControl(''),
  });

  public readonly upcomingGroupsData: UpcomingGroupData[] = [];

  constructor(
    public breakpointObserverService: BreakpointObserverService,
    public accessService: UserAccessService,
    public layersMenuService: LayersMenuService,
    public menuSearchService: MenuSearchService,
    public menuPresetService: MenuPresetService
  ) {
    this.industries = Industries;
  }

  ngOnInit(): void {}

  public identify(index: number, item: MenuGroupData): string {
    return item.title;
  }

  public identifyUpcoming(index: number, item: UpcomingGroupData): string {
    return item.title;
  }

  protected readonly MAPS_GROUP = MAPS_GROUP;
  protected readonly CHARTS_GROUP = CHARTS_GROUP;
  protected readonly PLACES_GROUP = PLACES_GROUP;
  protected readonly ALL_DATA_GROUP = ALL_DATA_GROUP;
}
